import React from 'react';

const CompanyContext = React.createContext({
    id: null,
    company: null,
});

CompanyContext.create = (id, company) => ({
    id,
    company,
});

const withCompanyContext = Component => {
    return function WrapperComponentContext(props) {
        return (
            <CompanyContext.Consumer>
                {company => <Component {...props} company={company} />}
            </CompanyContext.Consumer>
        );
    };
};

export { CompanyContext, withCompanyContext };
